import { meta } from '../../../../constants';
import type { DemoSourceType } from '../types';
import type { RSSSourceValue } from './types';

const extraRssSources: DemoSourceType<RSSSourceValue> = {
  'rss-fashionbeans': {
    label: 'RSS: www.fashionbeans.com',
    source: {
      platform: 'rss',
      connectionType: 'rssFile',
      id: 'kgte8a3f',
      name: 'RSS',
      source: 'https://www.fashionbeans.com/rss-feed/'
    }
  },
  'rss-iso.500px': {
    label: 'RSS: iso.500px.com',
    source: {
      platform: 'rss',
      connectionType: 'rssFile',
      id: 'kgte8a5f',
      name: 'RSS',
      source: 'https://iso.500px.com/feed/'
    }
  },
  'rss-designshack': {
    label: 'RSS: designshack.com',
    source: {
      platform: 'rss',
      connectionType: 'rssFile',
      id: 'kgte8a6f',
      name: 'RSS',
      source: 'https://feedpress.me/designshack'
    }
  },
  'rss-zilliondesigns': {
    label: 'RSS: www.zilliondesigns.com',
    source: {
      platform: 'rss',
      connectionType: 'rssFile',
      id: 'kgte8a7f',
      name: 'RSS',
      source: 'https://www.zilliondesigns.com/blog/feed/'
    }
  },
  'rss-skysports': {
    label: 'RSS: www.skysports.com',
    source: {
      platform: 'rss',
      connectionType: 'rssFile',
      id: 'kgte8a9f',
      name: 'RSS',
      source: 'https://www.skysports.com/rss/12040'
    }
  }
};

export const previewRssSources: DemoSourceType<RSSSourceValue> = {
  'rss-nasa-breaking_news': {
    label: 'RSS: www.nasa.gov',
    source: {
      platform: 'rss',
      connectionType: 'rssFile',
      id: 'kgte8a1f',
      name: 'RSS',
      source: 'https://www.nasa.gov/rss/dyn/breaking_news.rss'
    }
  },
  'rss-yardbarker': {
    label: 'RSS: www.yardbarker.com',
    source: {
      platform: 'rss',
      connectionType: 'rssFile',
      id: 'kgte8a2f',
      name: 'RSS',
      source: 'https://www.yardbarker.com/rss/rumors'
    }
  },
  'rss-elfsight': {
    label: 'RSS: elfsight.com/feed',
    source: {
      platform: 'rss',
      connectionType: 'rssFile',
      id: 'kgte8a3f',
      name: 'RSS',
      source: 'https://elfsight.com/feed'
    }
  },
  ...(meta.alias === 'rss-feed' ? extraRssSources : {})
};
